import appConfig from "@core/config";
import { CourseStatus } from "@core/enumsV2";
import type { CourseDto, ExtendedCourseDto } from "@core/typesV2";
import { type NavigateFunction } from "react-router-dom";
import { z } from "zod";

import AxiosService, { type TokenHandlers } from "./axiosServiceV2";

export default class CourseService extends AxiosService {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super(
      `${appConfig.LEARNING_BASE_URL}/api/v1/courses`,
      tokenHandlers,
      navigateTo,
    );
  }

  getCourseById(courseId: string, learnerId?: string) {
    return this.get<ExtendedCourseDto>(
      `${courseId}${learnerId ? `?requestedLearnerId=${learnerId}` : ""}`,
    );
  }

  getCoursesByStatus(status: CourseStatus, searchQuery: string) {
    return this.get<CourseDto[]>("", {
      params: { courseStatus: status, query: encodeURIComponent(searchQuery) },
    });
  }

  async getCourseCountByStatus(status: CourseStatus) {
    const { headers } = await this.head("", {
      params: { courseStatus: status },
    });

    return z.coerce.number().safeParse(headers["x-total-count"]).data ?? null;
  }
}
